export const DEBUG_ANALYTICS = false; // Set to false in production

/**
 * Track custom events in Google Analytics
 * @param category Event category
 * @param action Event action
 * @param label Event label (optional)
 * @param value Event value (optional)
 */
export const trackEvent = ({
    category,
    action,
    label,
    value,
}: {
    category: string;
    action: string;
    label?: string;
    value?: string | number;
}) => {
    if (typeof window !== "undefined" && window.gtag) {
        if (DEBUG_ANALYTICS) {
            console.group("🔍 Google Analytics Event");
            console.log("Action:", action);
            console.log("Params:", {
                event_category: category,
                event_label: label,
                value: value,
            });
            console.groupEnd();
        }

        window.gtag("event", action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};
